import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VisitorManagementService } from '../visitor-management.service';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { AppQrCodeService } from 'src/app/core/components/app-qr-code/app-qr-code.service';
import { EcPoliciesService } from 'src/app/contractor/ec-policies';
import { forkJoin } from 'rxjs';
import { AttendanceService } from 'src/app/attendance/attendance.service';
import { DataShareService } from 'src/app/service/data-share.service';
import { GLOBAL } from 'src/app/app.globals';
import { LaboursService } from 'src/app/labour/labours/labours.service';

@Component({
  selector: 'app-generate-qr-visitor',
  templateUrl: './generate-qr-visitor.component.html',
  styleUrls: ['./generate-qr-visitor.component.css']
})
export class GenerateQrVisitorComponent implements OnInit {
  hideUpdateiteams: boolean = true;
  editIndex: number = -1;
  iteamsViews: any[] = [];
  userId = localStorage.getItem('UserID') || '100';
  createFormGroup(fields: string[], requiredFields: string[] = []): FormGroup {
    const group: any = {};
    fields.forEach(field => {
      group[field] = new FormControl(null, requiredFields.includes(field) ? Validators.required : null);
    });
    return new FormGroup(group);
  }

  visitorForm = this.createFormGroup([
    "Company_Code", "Plant_Code", "yourcompany", "name", "jobtitle",
    "mobileno", "emailid", "pgender",
    "passportNo", "panNo",
    "emergencycontactname", "emergencycontactno",
    "PCountry_Code", "address", "landmark", "zipcode", "PState_Code", "PDistrict_Code", "PCity_Code", 
    "PPostOffice_Code",
    "visitorcategoryasterList_Code", "TypeOfIdentityMasterItem_Code", 
    "addharNo", "drvingLicense", "electionCard",
    "Remark", "visitorpurposeMasterList_Code", "purposeofvisit1",
    "iteamtype", "iteamdescription", "serialno", "isreturnable"
  ], [
    "yourcompany",
    "name",
    "jobtitle",
    "mobileno",
    "emailid",
    "emergencycontactname",
    "emergencycontactno",
    "visitorcategoryasterList_Code",
    "TypeOfIdentityMasterItem_Code",
    "PCountry_Code"
  ]);

  public companyData: any[] = [];
  public plants: any[] = [];
  genderTypes: any;
  visitorcategory: any[] = [];
  identityTypes: any[] = [];
  show = false;
  showPan = false;
  showPassport = false;
  showelectioncard = false;
  iteamtypes: any;
  visitorpurposetypeList: any;
  pStates: any[] = [];
  pCities: any[] = [];
  pPos: any[] = [];
  pcountries = [];
  pDistricts = [];
  shortCodeWiseObjectMapping: any;

  constructor(
    private service: VisitorManagementService,
    private attendanceService: AttendanceService,
    private ecpolicyService: EcPoliciesService,
    private dataShareService: DataShareService,
    private visitorManagementService : VisitorManagementService,
    private logHelperService: LogHelperService,
    private qrCodeService: AppQrCodeService
  ) {}

  ngOnInit() {
    this.initializeFormData();

    this.visitorForm.get('mobileno').setValidators([Validators.required, Validators.pattern(/^[0-9]{10}$/)]);
    this.visitorForm.get('emergencycontactno').setValidators([Validators.required, Validators.pattern(/^[0-9]{10}$/)]);
    this.visitorForm.get('emailid').setValidators([Validators.required, Validators.email]);
  }

  initializeFormData() {
    this.getVisitorCategory();
    this.identityProof();
    this.getCountry();
    this.getShortCodeWiseMasterList();
  }

  private getShortCodeWiseMasterList() {
    this.visitorManagementService.getMasterListData_V2("GM1080,GM1073", null).subscribe(
      (res: any) => {
        const responseList = Array.isArray(res) ? res : [];
        const itemTypeGroup = responseList.find((x: any) => Number(x.Parent_Code) === 1079);
        const purposeTypeGroup = responseList.find((x: any) => Number(x.Parent_Code) === 1073);

        const itemTypeValues = Array.isArray(itemTypeGroup.Values) ? itemTypeGroup.Values : [];
        const purposeTypeValues = Array.isArray(purposeTypeGroup.Values) ? purposeTypeGroup.Values : [];

        this.iteamtypes = itemTypeValues.map((item: any) => ({
          MasterItem_Code: item.MasterItem_Code,
          Name: item.Name,
        }));

        this.visitorpurposetypeList = purposeTypeValues.map((item: any) => ({
          MasterItem_Code: item.MasterItem_Code,
          Name: item.Name,
        }));
      },
      (error: any) => {
        this.iteamtypes = [];
        this.visitorpurposetypeList = [];
      }
    );
  }

  getVisitorCategory() {
    const reqObj: any = {
      ShortCode: null,
      Search: null,
      Parent_Code: 1065,
      Page_Code: 424,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    };
    this.service.visitorCategorys(reqObj).subscribe((response: any) => {
      this.visitorcategory = response;
    });
  }

  identityProof() {
    const reqObj: any = {
      ShortCode: null,
      Search: null,
      Parent_Code: 575,
      Page_Code: 424,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    };
    this.service.getIdentityProof(reqObj).subscribe((response: any) => {
      this.identityTypes = response;
    });
  }

  getCountry() {
    return this.service.getCountry().subscribe((response: any) => {
      this.pcountries = response;
    });
  }

  getStatesByCountryId() {
    return this.service.getStatesByCountryId(this.visitorForm.controls['PCountry_Code'].value || 100).subscribe((response: any) => {
      this.pStates = response;
    });
  }

  getDistrictsByStateP() {
    return this.service.getDistrictsByState(this.visitorForm.controls['PState_Code'].value || 100)
      .subscribe((response: any) => {
        this.pDistricts = response;
      });
  }

  getCitiesByDistrict() {
    const districtControl = this.visitorForm.get('PDistrict_Code');
    const districtCode = districtControl ? districtControl.value : null;
    return this.service.getCitiesByDistrict(districtCode || 100).subscribe((response: any) => {
      this.pCities = response;
    });
  }

  getPostOfficeByCity() {
    const cityControl = this.visitorForm.get('PCity_Code');
    const cityCode = cityControl ? cityControl.value : null;
    return this.service.getPOsByCity(cityCode || 100).subscribe((res: any) => {
      this.pPos = res;
    });
  }

  changeIdentitytype() {
    const typeValue = this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].value;
    const addhar = this.visitorForm.get('addharNo');
    const pan = this.visitorForm.get('panNo');
    const passport = this.visitorForm.get('passportNo');
    const election = this.visitorForm.get('electionCard');
    const driving = this.visitorForm.get('drvingLicense');

    this.show = false;
    this.showPan = false;
    this.showPassport = false;
    this.showelectioncard = false;

    [addhar, pan, passport, election, driving].forEach(ctrl => {
      if (ctrl) {
        ctrl.clearValidators();
        ctrl.updateValueAndValidity();
      }
    });

    if (typeValue === 577) { // Aadhar
      this.show = true;
      addhar.setValidators([Validators.required]);
    } else if (typeValue === 576) { // PAN
      this.showPan = true;
      pan.setValidators([Validators.required]);
    } else if (typeValue === 578) { // Election
      this.showelectioncard = true;
      election.setValidators([Validators.required]);
    } else if (typeValue === 580) { // Passport
      this.showPassport = true;
      passport.setValidators([Validators.required]);
    }

    [addhar, pan, passport, election, driving].forEach(ctrl => {
      if (ctrl) {
        ctrl.updateValueAndValidity();
      }
    });
  }

  generateQRCode(_serialNo: string) {
    const qrPayload = this.buildVisitorQrPayload();
    this.openVisitorQrModal(qrPayload);
  }

  generateBarCode(_serialNo: string) {
    console.log('Generate Bar Code for:', _serialNo);
  }

  AddIteams() {
    let formData = this.visitorForm.value;
    if (!formData.iteamtype || !formData.iteamdescription || !formData.serialno) {
      this.logHelperService.logError({ message: 'Please Fill Item Type, Item Description, and Serial No' });
      return;
    }

    this.iteamtypes.forEach((result) => {
      if (result.MasterItem_Code == formData.iteamtype) {
        let reqObj = {
          ID: null,
          Visitor_Code: null,
          ItemTypeMasterItem_Code: formData.iteamtype,
          ItemTypeMasterItem_Name: result.Name,
          ItemDescription: formData.iteamdescription,
          SerialNo: formData.serialno,
          isreturnable: formData.isreturnable !== undefined ? formData.isreturnable : false
        };
        this.iteamsViews.push(reqObj);
        this.visitorForm.patchValue({
          iteamtype: null,
          iteamdescription: null,
          serialno: null,
          isreturnable: null,
        });
      }
    });
  }

  edititeams(index: number) {
    this.hideUpdateiteams = false;
    this.editIndex = index;
    let result = this.iteamsViews[index];
    this.visitorForm.patchValue({
      iteamtype: result.ItemTypeMasterItem_Code,
      iteamdescription: result.ItemDescription,
      serialno: result.SerialNo,
      isreturnable: Boolean(result.isreturnable)
    });
  }

  updateiteams() {
    if (this.editIndex < 0) return;
    const formData = this.visitorForm.value;
    if (!formData.iteamtype || !formData.iteamdescription || !formData.serialno) {
      this.logHelperService.logError({ message: 'Please Fill Item Type, Item Description, and Serial No' });
      return;
    }

    this.iteamtypes.forEach((result) => {
      if (result.MasterItem_Code == formData.iteamtype) {
        this.iteamsViews[this.editIndex] = {
          ID: this.iteamsViews[this.editIndex].ID || null,
          Visitor_Code: null,
          ItemTypeMasterItem_Code: formData.iteamtype,
          ItemTypeMasterItem_Name: result.Name,
          ItemDescription: formData.iteamdescription,
          SerialNo: formData.serialno,
          isreturnable: formData.isreturnable !== undefined ? formData.isreturnable : false
        };
        this.visitorForm.patchValue({
          iteamtype: null,
          iteamdescription: null,
          serialno: null,
          isreturnable: null,
        });
        this.editIndex = -1;
        this.hideUpdateiteams = true;
      }
    });
  }

  deleteiteams(index: number) {
    this.iteamsViews.splice(index, 1);
    this.hideUpdateiteams = true;
  }

  public GenerateQR(): void {
    debugger;
    Object.keys(this.visitorForm.controls).forEach(key => {
      this.visitorForm.get(key).markAsTouched();
    });
    if (this.visitorForm.invalid) {
      return;
    }

    const qrPayload = this.buildVisitorQrPayload();
    this.openVisitorQrModal(qrPayload);
    this.logHelperService.logSuccess({ message: 'QR Code generated successfully. When scanned, it will pre-fill the visitor form.' });
  }

  private buildVisitorQrPayload(): any {
    const value = this.visitorForm.getRawValue();
    return {
      type: 'visitor_pre_request',
      version: 1,
      data: {
        Company_Code: value.Company_Code,
        Plant_Code: value.Plant_Code,
        VisitorCompany: value.yourcompany,
        FullName: value.name,
        JobTitle: value.jobtitle,
        MobileNo: value.mobileno,
        EmailID: value.emailid,
        GenderMAsterItem_Code: value.pgender,
        EmergancyContactName: value.emergencycontactname,
        EmergancyContactNo: value.emergencycontactno,
        Address1: value.address,
        Address2: value.landmark,
        ZipCode: value.zipcode,
        Country_Code: value.PCountry_Code,
        State_Code: value.PState_Code,
        City_Code: value.PCity_Code,
        PostOffice_Code: value.PPostOffice_Code,
        VisitorCategoryMIL_Code: value.visitorcategoryasterList_Code,
        VisitorPurposeTypeMIL_Code: value.visitorpurposeMasterList_Code || 1075,
        Visitorpurpose: value.purposeofvisit1,
        IDProofTypeMIL_Code: value.TypeOfIdentityMasterItem_Code,
        AddharNo: value.addharNo || null,
        PassportNo: value.passportNo || null,
        PanNo: value.panNo || null,
        ElectionCardNo: value.electionCard || null,
        DrivingLicenceNo: value.drvingLicense || null,
        Remark: value.Remark || '',
        Items: this.iteamsViews || []
      }
    };
  }

  private openVisitorQrModal(payload: any): void {
    const qrDataString = JSON.stringify(payload);
    this.qrCodeService.generateQRCode(qrDataString);
  }

}
